import { Form } from 'antd';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  AuthFooterLink,
  AuthSubmitButton,
  EmailField,
} from '@/components/auth';
import styles from '@/components/auth/AuthForm.module.scss';
import { ROUTES } from '@/constants/routes';
import { useMutationReset } from '@/hooks/useMutationReset';
import { useNotify } from '@/hooks/useNotify';
import { useForgotPasswordMutation } from '@/modules/auth/authApi';
import type { ForgotPasswordPayload } from '@/types/auth';
import { resolveMutationResult } from '@/utils/apiResponse';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const notify = useNotify();
  const [forgotPassword, { isLoading, reset }] = useForgotPasswordMutation();
  const { control, handleSubmit } = useForm<ForgotPasswordPayload>({
    defaultValues: { username: '' },
  });

  useMutationReset(reset);

  const onSubmit = async (values: ForgotPasswordPayload) => {
    const result = await resolveMutationResult(forgotPassword(values));

    if (!result.ok) {
      notify.error(result.message);
      return;
    }

    navigate(`${ROUTES.VERIFY_OTP}?email=${encodeURIComponent(values.username)}`, {
      state: { apiMessage: result.message },
    });
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onSubmit)} className={styles.form}>
      <EmailField control={control} name="username" />
      <Form.Item>
        <AuthSubmitButton label="Send OTP" loading={isLoading} />
      </Form.Item>
      <AuthFooterLink to={ROUTES.LOGIN} label="Back to login" />
    </Form>
  );
}
